import ApiService from "services/ApiService";
import ApiRequestService from "services/ApiRequestService";

const badRequestCode = 400;

export const LicenceCheckingService = {
    getLicenceCheckingOptions() {
        return new Promise((resolve, reject) => {
            ApiService.get(`/employee/Options/LicenceChecking`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getLicenceCheckingSettings() {
        return new Promise((resolve, reject) => {
            ApiService.get(`/employee/LicenceCheckingSettings`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    saveLicenceCheckingSettings(settings) {
        return new Promise((resolve, reject) => {
            ApiService.put("/employee/LicenceCheckingSettings", settings)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    getLicenceCheckingAlertsSettings() {
        return new Promise((resolve, reject) => {
            ApiService.get(`/employee/LicenceCheckingSettings/Alerts`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    saveLicenceCheckingAlertsSettings(settings) {
        return new Promise((resolve, reject) => {
            ApiService.put("/employee/LicenceCheckingSettings/Alerts", settings)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    getLicenceCheckingUsers(searchPayload) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/user/LicenceCheckingUsers/Search`,
                searchPayload
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getLicenceCheckingUser(userId) {
        return ApiRequestService.get(
            "user",
            `LicenceCheckingUsers/${userId}`
        );
    },
    deleteLicenceCheckingUser(userId) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/user/LicenceCheckingUsers/${userId}`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getChangeLog(changeLogType, pageSize, pageNumber, startDate, endDate) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/ChangeLog/LicenceChecking?changeLogType=${changeLogType}&resultCount=${pageSize}&pageNumber=${pageNumber}&startDate=${startDate}&endDate=${endDate}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getCreditsHistory(pageSize, pageNumber, startDate, endDate) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/LicenceCheckingCredits/History?resultCount=${pageSize}&pageNumber=${pageNumber}&startDate=${startDate}&endDate=${endDate}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error.response);
                }
            );
        });
    },
    getCreditsHistoryForEmployee(
        employeeId,
        pageSize,
        pageNumber,
        startDate,
        endDate
    ) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/LicenceCheckingCredits/History/Employee/${employeeId}?resultCount=${pageSize}&pageNumber=${pageNumber}&startDate=${startDate}&endDate=${endDate}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error.response);
                }
            );
        });
    },
    generateCreditReport(startDate, endDate) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/employee/LicenceCheckingReports/Credits`, {
                startDate: startDate,
                endDate: endDate,
            }).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error.response);
                }
            );
        });
    },
    getCreditsForecast() {
        return new Promise((resolve, reject) => {
            ApiService.get("/employee/LicenceCheckingCredits/Forecast").then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error.response);
                }
            );
        });
    },
    getCreditExpiry() {
        return ApiRequestService.get("employee", "LicenceCheckingCredits/Expiry");
    },
    getCredits() {
        return new Promise((resolve, reject) => {
            ApiService.get("/employee/LicenceCheckingCredits").then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error.response);
                }
            );
        });
    },
    editLicenceCheckingUser(id, roles) {
        return new Promise((resolve, reject) => {
            ApiService.put(`/user/LicenceCheckingUsers/${id}`, roles).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    addUser(user) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/user/LicenceCheckingUsers`, user).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    deletePolicy(policyId) {
        return new Promise((resolve, reject) => {
            ApiService.delete(
                `/employee/LicenceCheckingPolicies/${policyId}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    searchPolicies(pageSize, pageNumber, sortField, sortDirection) {
        var searchObject = {
            requestCount: pageSize,
            pageNumber: pageNumber,
            SearchTerm: "",
            sortField: sortField,
            sortDirection: sortDirection,
            Filters: [],
        };
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/employee/LicenceCheckingPolicies/Search`,
                searchObject
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    purchaseCredits(order) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                "/employee/LicenceCheckingCredits/PurchaseOrder",
                order
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getPolicyCreditEstimate(searchObject) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/employee/LicenceCheckingPolicies/CreditEstimate`,
                searchObject
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    createPolicy(policy) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/employee/LicenceCheckingPolicies`, policy).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    updatePolicy(policy, id) {
        return new Promise((resolve, reject) => {
            ApiService.put(
                `/employee/LicenceCheckingPolicies/${id}`,
                policy
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getPolicy(id) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/employee/LicenceCheckingPolicies/${id}`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getLatestLicenceCheck(employeeId) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/LicenceChecking/employee/${employeeId}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getLicenceCheck(employeeId, checkId) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/LicenceChecking/employee/${employeeId}/check/${checkId}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    performManualCheck(employeeId) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/employee/LicenceChecking/manual/${employeeId}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    checkManualCheckProgress(queueId) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/LicenceChecking/QueueStatus/${queueId}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    confirmLicenceMismatch(consentId, updateLicenceNumber) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/employee/LicenceCheckingConsent/${consentId}/ConfirmDetails`,
                updateLicenceNumber
            ).then(
                () => {
                    resolve();
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    deleteLicenceCheckingData(employeeId) {
        return new Promise((resolve, reject) => {
            ApiService.delete(
                `/employee/LicenceChecking/Employee/${employeeId}`
            ).then(
                () => {
                    resolve();
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    sendDriverDeclaration(consentRequest) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/employee/LicenceCheckingConsent`,
                consentRequest
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    rejectConsent(id, rejectConsent) {
        return new Promise((resolve, reject) => {
            ApiService.patch(
                `/employee/LicenceCheckingConsent/${id}/Reject`,
                rejectConsent
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getConsent(employee, code, email) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/LicenceCheckingConsent?employee=${employee}&code=${code}&email=${email}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    saveConsent(id, consent) {
        return new Promise((resolve, reject) => {
            ApiService.put(
                `/employee/LicenceCheckingConsent/${id}`,
                consent
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getOnboardingStats(locationsIds) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                "/employee/LicenceChecking/Onboarding/Stats",
                locationsIds
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getCheckStats(locationsIds) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                "/employee/LicenceChecking/Check/Stats",
                locationsIds
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getCompletedChecks(searchPayload) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                "/employee/LicenceChecking/Check/Search",
                searchPayload
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getOnboardingListing(searchPayload) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                "/employee/LicenceChecking/Onboarding/Search",
                searchPayload
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    generateOnboardingReport(filters) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/employee/LicenceCheckingReports/Onboarding`, {
                filters: filters,
            }).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error.response);
                }
            );
        });
    },
    generateCompletedChecksReport(filters) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/employee/LicenceCheckingReports/Check`, {
                filters: filters,
            }).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error.response);
                }
            );
        });
    },
    getInsuranceDetails(employee, code) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/GreyFleetInsurance?employee=${employee}&token=${code}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    saveInsuranceDetails(insuranceDetails) {
        return new Promise((resolve, reject) => {
            ApiService.put(
                `/employee/GreyFleetInsurance`,
                insuranceDetails
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    rejectInsuranceUpload(rejectDetails) {
        return new Promise((resolve, reject) => {
            ApiService.patch(
                `/employee/GreyFleetInsurance/Reject`,
                rejectDetails   
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getGreyFleetSettings() {
        return new Promise((resolve, reject) => {
            ApiService.get(`/employee/GreyFleetSettings`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    saveGreyFleetSettings(settings) {
        return new Promise((resolve, reject) => {
            ApiService.put("/employee/GreyFleetSettings", settings).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getGreyFleetPolicy() {
        return new Promise((resolve, reject) => {
            ApiService.get(`/employee/GreyFleetSettings/Policy`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    saveGreyFleetPolicy(policy) {
        return new Promise((resolve, reject) => {
            ApiService.put("/employee/GreyFleetSettings/Policy", policy).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getGreyFleetSettingsHistory(changeLogType, pageSize, pageNumber, startDate, endDate) {

        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/Changelog/GreyFleet?resultCount=${pageSize}&pageNumber=${pageNumber}&startDate=${startDate}&endDate=${endDate}&changeLogType=${changeLogType}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error.response);
                }
            );
        });
    },
    getGreyFleetEmployeeSearch(searchPayload){
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/employee/GreyFleet/Employee/Search`,
                searchPayload
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    createGreyFleetCheck(employeeId, emailAndRegistration) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/employee/GreyFleet/employee/${employeeId}`,
                emailAndRegistration
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getGreyFleetStats(locationIds) {
        return new Promise((resolve, reject) => {
            ApiService.post(`/employee/GreyFleet/Check/Stats`, {
                locationIds: locationIds,
            }).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    searchGreyFleetChecks(searchPayload) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                "/employee/GreyFleet/Search",
                searchPayload
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getGreyFleetCheck(checkId) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/GreyFleet/Check/${checkId}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    deleteGreyFleetCheck(checkId) {
        return new Promise((resolve, reject) => {
            ApiService.delete(
                `/employee/GreyFleet/${checkId}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    enrollGreyFleetCheck(id, enroll, ignorePolicyCheck, requiredCoverTypeIds){
        return new Promise((resolve, reject) => {
            ApiService.patch(
                `/employee/GreyFleet/${id}/Enroll`,
                { enroll: enroll, ignorePolicyCheck: ignorePolicyCheck, requiredCoverTypeIds: requiredCoverTypeIds }
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    // A timeout or network failure has no response, so the status is read defensively
                    // to keep the promise settling.
                    if (error.response?.status === badRequestCode) {
                        reject(error.response.data);
                    } else {
                        reject(error.response);
                    }
                }
            );
        });
    },
    addMissingVehicleDetails(id, missingDetails){
        return new Promise((resolve, reject) => {
            ApiService.put(
                `/employee/GreyFleet/${id}/MissingPolicyInfo`,
                missingDetails
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    recheckGreyFleetCheck(checkId) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/employee/GreyFleet/${checkId}/Recheck`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getInsuranceDocument(checkId) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/employee/GreyFleet/${checkId}/InsuranceDocument`)
                .then(
                    (result) => {
                        resolve(result.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });
    },
    resendInsuranceDetailsReminder(checkId) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/employee/GreyFleetInsurance/Check/${checkId}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    getOnSiteDeclarationDetails(employeeId) {
        return new Promise((resolve, reject) => {
            ApiService.get(
                `/employee/LicenceCheckingConsent/OnSite/${employeeId}`
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    submitOnSiteDeclaration(payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(
                `/employee/LicenceCheckingConsent/OnSite`,
                payload
            ).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }
};
